import utilsMixin from 'root/mixins/utilsMixin.js'

export default {
    mixins: [utilsMixin],
    methods: {
      updateFacetData: function(response) {
        this.$root.searchPageData = JSON.parse(response.bodyText).searchPageData
        this.$root.$emit('update-product-grid-results', JSON.parse(response.bodyText).searchPageData.results)
        window.history.pushState({},"", this.$root.searchPageData.currentQuery.url)
      }
    }
  }


// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/mixins/facetsMixin.js